import { AbpSessionService, PermissionCheckerService } from "abp-ng2-module";
import { Injector, ElementRef, Component, OnInit, ViewEncapsulation, Inject, Renderer2, AfterViewInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";
import { AppMenu } from "./app-menu";
import { AppNavigationService } from "./app-navigation.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { MenuOptions } from "@metronic/app/core/_base/layout/directives/menu.directive";
import { FormattedStringValueExtracter } from "@shared/helpers/FormattedStringValueExtracter";
import * as objectPath from "object-path";
import {
    CommonCacheServiceProxy,
    CompanyProfileServiceProxy,
    ProjectListViewSummaryDto,
    SessionServiceProxy,
    TimesheetServiceProxy,
    UserLoginServiceProxy,
    UserServiceProxy,
} from "../../../../shared/service-proxies/service-proxies";
import { forEach } from "lodash-es";
import { AppConsts } from "@shared/AppConsts";
import { AppMenuItem } from "./app-menu-item";
import * as _ from "lodash";
import { QuickStartLoginSuccessService } from "../../services/quick-start-login-success.service";
import { Subscription } from "rxjs";
import { NewQuickStartService } from "../../../main/Service/new-quick-start.service";

@Component({
    templateUrl: "./side-bar-menu.component.html",
    selector: "side-bar-menu",
    encapsulation: ViewEncapsulation.None,
    providers: [NewQuickStartService]
})
export class SideBarMenuComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {
    menu: AppMenu = null;

    currentRouteUrl = "";
    insideTm: any;
    outsideTm: any;
    rootMenus: string[] = [];
    isLoginForFirstTime  : boolean = false;
    subscription: Subscription;
    checkLogin: boolean = false;
    menuOptions: MenuOptions = {
        submenu: {
            desktop: {
                default: "dropdown",
            },
            tablet: "accordion",
            mobile: "accordion",
        },

        accordion: {
            expandAll: false,
        },
    };

    constructor(
        injector: Injector,
        private el: ElementRef,
        private _router: Router,
        private _route: ActivatedRoute,
        public permission: PermissionCheckerService,    
        private _userServiceProxy: UserServiceProxy,
        private _abpSessionService: AbpSessionService,
        private _sessionServiceProxy: SessionServiceProxy,
        private _appNavigationService: AppNavigationService,
        private _companyProfileServiceProxy: CompanyProfileServiceProxy,
        private render: Renderer2,
        private _tsProxy: TimesheetServiceProxy,
        private _userLoginAppService: UserLoginServiceProxy,
        private _commonCacheServiceProxy: CommonCacheServiceProxy,
        private _NewQuickStartService: NewQuickStartService,
        private cdRef: ChangeDetectorRef,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.checkLoginSuccessForSideBar();
        this.getUserWiseOtherSetting();
        let thisObj = this;
        abp.event.on('checkLoginSuccessForSideBar', function () { thisObj.checkLoginSuccessForSideBar(); });
        abp.event.on('isSideBarToggle', function (data) { thisObj.isSideBarToggle(data); });
        this.checkLogin = JSON.parse(localStorage.getItem('checkLoginSuccess'));

        if (this.checkLogin) {
            abp.event.trigger('checkLoginSuccessFordefault');
            abp.event.trigger('checkLoginForTopbardownload');
            abp.event.trigger('checkLoginForTopbarSetting');
        }
        //this._companyProfileServiceProxy.getCaptureSettingForEditView(1).subscribe(x => {
        //    console.log(x);
        //    this.menu = this._appNavigationService.getMenu();

        //    if (x.isProjectSec)
        //        this.hideMainMenuFromLeftSection('Projects');
        //    if (x.isDashboard)
        //        this.hideMainMenuFromLeftSection('Dashboard');
        //    if (x.isDashboard)
        //        this.hideMainMenuFromLeftSection('Dashboard');
        //    if (x.isHideSS)
        //        this.hideChildMenuFromLeftSection('Screenshots');
        //    if (x.isHideInvSec)
        //        this.hideMainMenuFromLeftSection('Invoice');

        //    this.findAllRootMenus(this.menu.items);

        //    this.currentRouteUrl = this._router.url.split(/[?#]/)[0];

        //    this._router.events
        //        .pipe(filter((event) => event instanceof NavigationEnd))
        //        .subscribe(
        //            (event) =>
        //                (this.currentRouteUrl = this._router.url.split(/[?#]/)[0])
        //        );
        //});
    }
    //
    // Get User Wise setting and Hide Perticular Menu
    //


    async checkLoginSuccessForSideBar() {
        this.checkLogin = JSON.parse(localStorage.getItem('checkLoginSuccess'));
    }
  

    async getUserWiseOtherSetting() {
        // this._userServiceProxy.getUserTrackOtherSettingForEdit(this._abpSessionService.tenantId, this._abpSessionService.userId).subscribe(x => {
        //     this.menu = this._appNavigationService.getMenu();
        //     if (x.isProjectSec)
        //         this.hideMainMenuFromLeftSection('Projects');
        //     if (x.isHideSS)
        //         this.hideChildMenuFromLeftSection('Screenshots');
        //     this.findAllRootMenus(this.menu.items);
        //     this.currentRouteUrl = this._router.url.split(/[?#]/)[0];
        //     this._router.events
        //         .pipe(filter((event) => event instanceof NavigationEnd))
        //         .subscribe(
        //             (event) =>
        //                 (this.currentRouteUrl = this._router.url.split(/[?#]/)[0])
        //         );
        // });
        let x;
        if (!AppConsts.userSettings && abp.session.tenantId) {
            x = await this._commonCacheServiceProxy.getUserTrackOtherSettingForEdit(abp.session.tenantId, abp.session.userId).toPromise();
            AppConsts.userSettings = x;
        } else {
            x = AppConsts.userSettings;
        }
        this.currentRouteUrl = this._router.url.split(/[?#]/)[0];
        this.menu = this._appNavigationService.getMenu();

        const a = this.menu.items.find(x => x.name == 'Activities').items.find(a => a.name == 'RealTimeTracking').name;
    
       // this.menu.items.splice(11, 1);

        this.injectMenuForClient();       
        if (x !== undefined) {
            if (x.isProjectSec) this.hideMainMenuFromLeftSection("Projects");
            if (x.isHideSS) this.hideChildMenuFromLeftSection("Screenshots");
        }       
        this.findAllRootMenus(this.menu.items);
        this._router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => (this.currentRouteUrl = this._router.url.split(/[?#]/)[0]));
    }

    async injectMenuForClient(): Promise<void> {
        // Commented to remove the duplicate API call getCurrentLoginInformations()
        
        // const userRoleClient = (await this._sessionServiceProxy.getCurrentLoginInformations().toPromise()).user.userRole.map(r => r.toLowerCase()).includes('client')
        const userRoleClient = AppConsts.userRoleArray.includes('client');
        if (!userRoleClient) return;
        const projectListForSumarry = await this._tsProxy.getProjectListForViewSummary([], []).toPromise();
        const projectList = await this._tsProxy.getProjectListForClient([], []).toPromise();
        projectList.forEach(x => {
           
        })
        this.menu.items.push(new AppMenuItem("Dashboard", null, "icon-dash", "/app/main/client-new/dashboard"))
        for (let i = 0; i < projectList.length; i++) {
            this.menu.items.push(this.createProjectMenuItem(projectList[i], projectListForSumarry.some(x => x.projectId === projectList[i].projectId)));
           
        }
        this.menu.items.push(new AppMenuItem("Reports", "", "icon-invoice", "/app/main/reports/reports"))

      
    }

    createProjectMenuItem(project: ProjectListViewSummaryDto, isClientApprover: boolean): AppMenuItem {
        let submenues = isClientApprover ? [
           
            new AppMenuItem("Team", null, "icon-Team", `/app/main/client-new/client-login-view-components/team`, undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Task", null, "icon-Task", `/app/main/client-new/client-login-view-components/task`, undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Timesheet View", null, "icon-TimeSheet", `/app/main/client-new/client-login-view-components/timesheet-details`, undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Work Schedule", null, "icon-Workschedule", '/app/main/client-new/client-login-view-components/work-schedule', undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Timesheet Summary", null, "icon-TimeSheetSummary", `/app/main/time-sheet/time-sheet-management`, undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Invoices", null, "icon-Invoices", '/app/main/client-new/client-login-view-components/all-invoices', undefined, undefined, undefined, { projectId: project.projectId }),
            new AppMenuItem("Consult Us", null, "icon-ConsultUs", '/app/main/client-new/client-login-view-components/consult-us', undefined, undefined, undefined, { projectId: project.projectId }),
        ] :
        [
                new AppMenuItem("Team", null, "icon-Team", `/app/main/client-new/client-login-view-components/team`, undefined, undefined, undefined, { projectId: project.projectId }),
                new AppMenuItem("Task", null, "icon-Task", `/app/main/client-new/client-login-view-components/task`, undefined, undefined, undefined, { projectId: project.projectId }),
                new AppMenuItem("Timesheet View", null, "icon-TimeSheet", `/app/main/client-new/client-login-view-components/timesheet-details`, undefined, undefined, undefined, { projectId: project.projectId }),
                new AppMenuItem("Work Schedule", null, "icon-Workschedule", '/app/main/client-new/client-login-view-components/work-schedule', undefined, undefined, undefined, { projectId: project.projectId }),
                new AppMenuItem("Invoices", null, "icon-Invoices", '/app/main/client-new/client-login-view-components/all-invoices', undefined, undefined, undefined, { projectId: project.projectId }),
                new AppMenuItem("Consult Us", null, "icon-ConsultUs", '/app/main/client-new/client-login-view-components/consult-us', undefined, undefined, undefined, { projectId: project.projectId }),
        ];
        return new AppMenuItem(
            _.capitalize(project.projectName),
            null,
            null,
            "",
            [],
            submenues,
            undefined,
            undefined,
            undefined,
            undefined,
            project.projectImage ? project.projectImage : "assets/common/images/projects/default image for project -1.png"
        );
    }

    ngAfterViewInit(): void {
        this.scrollToCurrentMenuElement();
        this.currentTheme.baseSettings.menu.submenuToggle = document.body.classList.contains("aside-minimize") ? 'true' : 'false';
        this.cdRef.detectChanges();
    }

    showMenuItem(menuItem): boolean {
        return this._appNavigationService.showMenuItem(menuItem);
    }

    isMenuItemIsActive(item): boolean {
        if (item.items.length) {
            return this.isMenuRootItemIsActive(item);
        }

        if (!item.route) {
            return false;
        }
        
        // let urlTree = this._router.parseUrl(this.currentRouteUrl.replace(/\/$/, ""));
        // let urlString = "/" + urlTree.root.children.primary.segments.map((segment) => segment.path).join("/");
        // let menuItemURL = item.route.replace(/\/$/, "");
        // let exactMatch = urlString === menuItemURL;
        // if (!exactMatch && item.routeTemplates) {
        //     for (let i = 0; i < item.routeTemplates.length; i++) {
        //         let result = new FormattedStringValueExtracter().Extract(urlString, item.routeTemplates[i]);
        //         if (result.IsMatch) {
        //             return true;
        //         }
        //     }
        // }
        if(this.currentRouteUrl.includes("appCategory") || this.currentRouteUrl.includes("services"))return false;
        let urlTree = this._router.parseUrl(this.currentRouteUrl.replace(/\/$/, ''));
        let urlString = '/' + urlTree.root.children.primary.segments.map(segment => segment.path).join('/');
        let menuItemURL = item.route.replace(/\/$/, "");
        let exactMatch = urlString.indexOf(item.route.replace(/\/$/, '')) > -1;
        if (!exactMatch && item.routeTemplates) {
            for (let i = 0; i < item.routeTemplates.length; i++) {
                let result = new FormattedStringValueExtracter().Extract(urlString, item.routeTemplates[i]);
                if (result.IsMatch) {
                    return true;
                }
            }
        }
         else {
            if (exactMatch) {
                if (menuItemURL === "/app/main/time-sheet/time-sheet-management" && this._route.snapshot.queryParams["projectId"] && (typeof item.parameters?.projectId === 'number')) {
                    let projectId = parseInt(this._route.snapshot.queryParams["projectId"]);
                    let projectIdFromParameters = item.parameters.projectId
                    if (projectId === projectIdFromParameters) return true;
                    return false;
                }


                if (menuItemURL === "/app/main/client-new/client-login-view-components/team" && this._route.snapshot.queryParams["projectId"] && (typeof item.parameters?.projectId === 'number')) {
                    let projectId = parseInt(this._route.snapshot.queryParams["projectId"]);
                    let projectIdFromParameters = item.parameters.projectId
                    if (projectId === projectIdFromParameters) return true;
                    return false;
                }

                if (menuItemURL === "/app/main/client-new/client-login-view-components/task" && this._route.snapshot.queryParams["projectId"] && (typeof item.parameters?.projectId === 'number')) {
                    let projectId = parseInt(this._route.snapshot.queryParams["projectId"]);
                    let projectIdFromParameters = item.parameters.projectId
                    if (projectId === projectIdFromParameters) return true;
                    return false;
                }

                if (menuItemURL === "/app/main/client-new/client-login-view-components/work-schedule" && this._route.snapshot.queryParams["projectId"] && (typeof item.parameters?.projectId === 'number')) {
                    let projectId = parseInt(this._route.snapshot.queryParams["projectId"]);
                    let projectIdFromParameters = item.parameters.projectId
                    if (projectId === projectIdFromParameters) return true;
                    return false;
                }

                if (menuItemURL === "/app/main/client-new/client-login-view-components/all-invoices" && this._route.snapshot.queryParams["projectId"] && (typeof item.parameters?.projectId === 'number')) {
                    let projectId = parseInt(this._route.snapshot.queryParams["projectId"]);
                    let projectIdFromParameters = item.parameters.projectId
                    if (projectId === projectIdFromParameters) return true;
                    return false;
                }

                if (menuItemURL === "/app/main/client-new/client-login-view-components/consult-us" && this._route.snapshot.queryParams["projectId"] && (typeof item.parameters?.projectId === 'number')) {
                    let projectId = parseInt(this._route.snapshot.queryParams["projectId"]);
                    let projectIdFromParameters = item.parameters.projectId
                    if (projectId === projectIdFromParameters) return true;
                    return false;
                }

                if (menuItemURL === "/app/main/client-new/client-login-view-components/timesheet-details" && this._route.snapshot.queryParams["projectId"] && (typeof item.parameters?.projectId === 'number')) {
                    let projectId = parseInt(this._route.snapshot.queryParams["projectId"]);
                    let projectIdFromParameters = item.parameters.projectId
                    if (projectId === projectIdFromParameters) return true;
                    return false;
                }

                if (menuItemURL === "/app/main/time-sheet/time-sheet-management" && this._route.snapshot.queryParams["projectId"] && (typeof item.parameters?.projectId === 'number')) {
                    let projectId = parseInt(this._route.snapshot.queryParams["projectId"]);
                    let projectIdFromParameters = item.parameters.projectId
                    if (projectId === projectIdFromParameters) return true;
                    return false;
                }
         
                return true;

               
            }
            if (!urlString.includes("/time-sheet/")) return false;

            let currentSubUrl = urlString.substring(0, urlString.lastIndexOf("/"));
            if (this.rootMenus.includes(currentSubUrl)) {
                return false;
            }
            let menuSubUrl = menuItemURL.substring(0, menuItemURL.lastIndexOf("/"));
            return currentSubUrl === menuSubUrl;
        }
        return exactMatch;
    }

    isMenuRootItemIsActive(item): boolean {
        let result = false;
        for (const subItem of item.items) {
            result = this.isMenuItemIsActive(subItem);
            if (result) {
                return true;
            }
        }
        return false;
    }

    findAllRootMenus(itemCollection) {
        let result = false;
        for (let subItem of itemCollection) {
            if (subItem.items.length) {
                let menuItemURL = subItem.items[0].route.replace(/\/$/, "");
                let menuSubUrl = menuItemURL.substring(0, menuItemURL.lastIndexOf("/"));
                this.rootMenus.push(menuSubUrl);
                this.findAllRootMenus(subItem.items);
            }
        }
    }

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseEnter(e: Event) {
        // check if the left aside menu is fixed
        if (document.body.classList.contains("aside-fixed")) {
            if (this.outsideTm) {
                clearTimeout(this.outsideTm);
                this.outsideTm = null;
            }

            this.insideTm = setTimeout(() => {
                // if the left aside menu is minimized
                if (
                    document.body.classList.contains("aside-minimize") &&
                    KTUtil.isInResponsiveRange("desktop") &&
                    document.body.classList.contains("aside-minimize-hoverable")
                ) {
                    // show the left aside menu
                    this.render.removeClass(document.body, "aside-minimize");
                    this.render.addClass(document.body, "aside-minimize-hover");
                }
            }, 50);
        }
        if (document.body.classList.contains("aside-minimize") &&
            !document.body.classList.contains("aside-menu-dropdown")
        ) {
            // show the left aside menu
            this.render.addClass(e.target, "aside-menu-dropdown");
        }
    }

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseLeave(e: Event) {
        if (document.body.classList.contains("aside-fixed")) {
            if (this.insideTm) {
                clearTimeout(this.insideTm);
                this.insideTm = null;
            }

            this.outsideTm = setTimeout(() => {
                // if the left aside menu is expand
                if (document.body.classList.contains("aside-minimize-hover") && KTUtil.isInResponsiveRange("desktop")) {
                    // hide back the left aside menu
                    this.render.removeClass(document.body, "aside-minimize-hover");
                    this.render.addClass(document.body, "aside-minimize");
                }
            }, 100);
        }
        this.render.removeClass(e.target, "aside-menu-dropdown");
    }

    scrollToCurrentMenuElement(): void {
        const path = location.pathname;
        const menuItem = document.querySelector("a[href='" + path + "']");
        if (menuItem) {
            menuItem.scrollIntoView({ block: "center" });
        }
    }

    getItemAttrSubmenuToggle(item) {
        let toggle = "hover";
        if (/* ||  this.currentTheme.baseSettings.menu.submenuToggle = 'false' objectPath.get(item, "toggle") === "click" &&*/ !document.body.classList.contains("aside-minimize")) {
            toggle = "click";
        } else if (objectPath.get(item, "submenu.type") === "tabs") {
            toggle = "tabs";
        } else {
            // submenu toggle default to 'hover'
        }

        return toggle;
    }
    isSideBarToggle(data) {
        this.ui.setSubmenuToggle(data);
        this._router.navigateByUrl(this._router.url); 
    }

    getItemCssClasses(item) {
        let classes = "menu-item";

        if (objectPath.get(item, "submenu")) {
            classes += " menu-item-submenu";
        }

        if (!item.items && this.isMenuItemIsActive(item)) {
            classes += " menu-item-active menu-item-here";
        }

        if (item.items && this.isMenuItemIsActive(item)) {
            classes += " menu-item-here";
            if (!document.body.classList.contains("aside-minimize")) classes += " menu-item-open"
        }

        // custom class for menu item
        const customClass = objectPath.get(item, "custom-class");
        if (customClass) {
            classes += " " + customClass;
        }

        if (objectPath.get(item, "icon-only")) {
            classes += " menu-item-icon-only";
        }

        return classes;
    }

    //
    // Hide Tab From Main Menus
    //
    hideMainMenuFromLeftSection(MenuName: string) {
        this.menu.items.forEach((item, index) => {
            if (item.name === MenuName) this.menu.items.splice(index, 1);
        });
    }
    //
    // Hide Tab From SubMenus
    //
    hideChildMenuFromLeftSection(SubMenuName: string) {
        this.menu.items.forEach((item, index) => {
            item.items.forEach((subitem, subidx) => {
                if (subitem.name === SubMenuName) this.menu.items[index].items.splice(subidx, 1);
            });
        });
    }



    ngOnDestroy() {
        //this.subscription.unsubscribe();
    }
}
